<template>
    <div class="bg"> 
        <div class="guide-pwa" v-if="!guide_show">
            <p class="guide-pwa-caption">Add FlexiSwiftLoan to the main page.</p>
            <button class="pwa-install" @click="installClick">Add</button>
        </div>       
        <Single :imgList="obj.imgList" :money='obj.money' v-if="user_status == 1" :list="obj.list"></Single>          
        <Multiple :imgList="obj.imgList" :list="obj.product_list" :ulist="obj.undway_list" v-if="user_status == 2"></Multiple>                  
        <div class="ios-guide-wrapper" v-show="ios_dialog_show">      
            <div class="ios-guide-content">
                <a href="javascript:void(0);" @click="ios_close" class="ios-close icon icon-ios-close"></a>
                <div class="guide-logo"></div>
                <h2 class='ios-guide-title'>
                Add FlexiSwiftLoan to the main page.
                </h2>      
                <ul class="ios-guide-list">
                <li class="ios-guide-element">
                    <span>1. Click "Share" </span>
                    <i class="icon icon-share"></i>
                </li>
                <li class="ios-guide-element">
                    <span>2. Click "Add to Home Screen"</span>
                    <i class="icon icon-ios-add"></i>
                </li>
                <li class="ios-guide-element">
                    3. Click "Add" 
                </li>
                </ul>
            </div>
        </div>
    </div>    
</template>
<style lang="less">
    .top-banner{
        width: 750px;
        height: 168px;
        background: #716BEA;
        line-height: 168px;
        color:#fff;
        font-size: 40px;
        text-align: center;
    }
    .bg{
        // background: url("~assets/images/index-bg.png") no-repeat;
        width: 750px;
        // min-height: 100vh;
    }
    @import "assets/less/icon.less";
  .pwa-install{
    display: block;
    width:150px;
    height:70px;
    line-height: 40px;
    text-align: center;
    font-size: 30px;
    color: #BE9060;
    border-radius: 10px;
    background:#fff;
    border: none;
  }
  .guide-pwa{
    padding:20px 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background:#BE9060;
    .guide-pwa-caption{
      font-size: 28px;
      color:#fff
    }
  }
  .ios-guide-wrapper{
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: rgba(0,0,0,0.6);
    z-index:100000;
    .ios-close{
      position: absolute;
      top:10px;
      right:10px;
    }
    .guide-logo{
      background:url("~assets/images/logo.png") no-repeat;
      width:150px;
      height:150px;
      background-size:100%;
      margin-top:-100px;
    }
    .ios-guide-title{
      color:#fff;
      font-size: 32px;
      word-break: break-all;
      margin-bottom: 30px;
      margin-top: 30px;
      font-weight: 700;      
    }
    .ios-guide-content{
      width: 500px;
      padding:25px;
      height:400px;
      position:absolute;
      left:50%;
      transform: translateX(-50%);
      bottom:20px;
      background: rgb(56, 55, 55);
      border-radius: 20px;
      .icon{
        display: inline-block;
        margin-left:15px;
        // background-color:#fff
      }
      :after{
          content:'';
          width: 0;
          height: 0;
          border-width:  0 20px 20px 20px;
          border-style: solid;
          border-color: transparent transparent  rgba(0,0,0,0.1);
          position: absolute;
          left: 50%;
          transform: translateX(-50%) rotate(180deg);
          bottom: -20px;
      }
      .ios-guide-list{
        .ios-guide-element{
          color:#ded5d5;
          font-size: 30px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }        
      }
    }
  }
</style>
<script>
import Single from '@/components/business/index/single.vue'
import Multiple from '@/components/business/index/multiple.vue'
import { reactive , onMounted, onBeforeMount,ref} from 'vue'
import { index, bury} from '../../api/index'
import { getToken,getTokenFromStorage } from '../../utils/tool'
// import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
export default {
    components:{
        Single,
        Multiple
    },
    setup () {  
        const loading = useLoading()  
        const store = useStore()  
        const user_status = ref(2)
        // const router = useRouter()  
        const beforeInstallEvent = ref(null)
        const global_clicked = ref(false)
        const ios_dialog_show = ref(false)
        const recommendPwa = ref(false)
        const guide_show = ref(false)
        const installingViaButton = ref('')
        const obj = reactive({
            state: 2,
            imgList: [],
            money: '',
            list:[],
            product_list:[],
            undway_list: [],
            logined: getTokenFromStorage() || getToken()
        })
        onBeforeMount(()=>{
            window.addEventListener("beforeinstallprompt", (e)=>{
                e.preventDefault()
                beforeInstallEvent.value = e
            })
        })
        onMounted(async () => {                   
            let isApp = store.state.isApp
            let u = navigator.userAgent;
            let isSafari = u.toLowerCase().indexOf("safari")!=-1 && navigator.userAgent.indexOf("Chrome") === -1
            recommendPwa.value = window.localStorage.getItem("recommendPwa") || false
            if(isApp) {
                guide_show.value = true  
            } else if(isSafari && !recommendPwa.value) {
                guide_show.value = false    
            } else if (beforeInstallEvent.value) {
                guide_show.value = false
            } else {
                guide_show.value = true
            }
            // guide_show.value = !recommendPwa.value && (isSafari || beforeInstallEvent.value) && !isApp


            const loader = loading.show({
                container: null
            })                        
            
            const data_2 = await index()     
            if(data_2.code == 0) {
                user_status.value = data_2.data.userStatus
                obj.list = data_2.data.homeProductVos
            }       
            loader.hide()
            if(data_2.data.homeProductVos!= null) {
                obj.product_list = data_2.data.homeProductVos
            } 
            if (data_2.data.undwayList != null) {
                obj.undway_list = data_2.data.undwayList
            }          
            console.log(obj.product_list);    
        })
        const ios_close = () => {
             ios_dialog_show.value = false
             guide_show.value = true
             bury({
                    "projectName":"Money Mint", 
                    "pageName":"index",
                    "behavior":"web_install_first",
                    "value":"closed",
                    "eventTime":""
                })
        }
        const installClick = async () => {
            let u = navigator.userAgent;
            let isSafari = u.toLowerCase().indexOf("safari")!=-1
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);       
            console.log(isIOS)
            console.log(u)
            if(isIOS && isSafari) {
                ios_dialog_show.value = true
                global_clicked.value = true
                window.localStorage.setItem("recommendPwa",true)
                guide_show.value = false
                bury({
                    "projectName":"Money Mint", 
                    "pageName":"index",
                    "behavior":"web_install_first",
                    "value":"clicked",
                    "eventTime":""
                })  
                return true
            }
            const t = beforeInstallEvent;
            if (!t)
                return;
            installingViaButton.value = !0,
            t.prompt();
            const {outcome: n} = await t.userChoice;
            console.log(n);    
            this.guide_show = false  
        }
        return {
            obj,
            ios_close,
            installClick,
            beforeInstallEvent,
            global_clicked,
            ios_dialog_show,
            recommendPwa,
            guide_show,
            user_status
        }
    }
}
</script>
